export const LinkOrderType = {
    none: 0,
    trip_number: 1,
    truck_id_and_time: 2,
    truck_and_time: 3,
}